import { useEffect, useState } from "react";
import { Row, Card, Form, Table, Button, InputGroup } from "react-bootstrap";
import API from "../../../services/axiosInstance";
import { useParams, Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import Permission from "../../security/permission";
import { AUTH_CODE } from "../../security/authCodes";

const ScheduleInstreamSetting = () => {
    const [list, setList] = useState([]);
    const [contentList, setContentList] = useState([]);
    const [publisherName, setPublisherName] = useState();
    const { register, handleSubmit } = useForm();

    const params = useParams();
    const instreamId = params?.instreamId;
    const instreamGuid = params?.instreamGuid;
    const pubGuid = params?.pubGuid;

    const accId = params?.accId
    // const queryParams = new URLSearchParams(location.search);


    const onSubmit = async (formData) => {
        try {
            const payload = {
                "id": 0,
                "instreamId": instreamId,
                "instreamGuid": instreamGuid,
                "pubGuid": pubGuid,
                "contentId": formData?.contentId,
                "scheduledDate": formData?.startDate
            }
            if (formData?.contentId != "" && formData?.startDate != "") {
                const res = await API.post(`/publisher/instream/setting/save/schedule/content`, payload);
                if (res?.data?.status === "Success") {
                    alert(res?.data?.message)
                    window.location.reload()
                } else {
                    alert(res?.data?.message || "Failed");
                    window.location.reload();
                }
            } else {
                alert("Please Select Content and Start Date!")
            }
        } catch (error) {
            console.error(error);
        }

    };

    // delete scheduled content
    const deleteScheduledContent = async (id, contentName) => {
        const confirmDelete = window.confirm("Do you want to delete " + contentName);
        try {
            if (confirmDelete) {
                const res = await API.delete(`/publisher/instream/setting/delete/schedule/content/${id}`);
                if (res?.data?.status === "Success") {
                    alert(res?.data?.message);
                    window.location.reload();
                } else {
                    alert(res?.data?.message)
                }
            }
        } catch (error) {
            console.error(error);
        }
        console.log(id);
    }

    const scheduleInstreamList = async () => {
        try {
            const res = await API.get(`/publisher/instream/setting/list/schedule/${instreamId}/${accId}`);
            if (res?.data?.status === "Success") {
                setList(res?.data?.data);
                setPublisherName(res?.data?.name);
                // console.log(res?.data?.data)
            }
        } catch (error) {
            console.error(error);
        }

    }

    const contentManagementList = async () => {
        try {
            const res = await API.get(`/meta/content/list/limited`);
            if (res?.data?.message === "OK") {
                setContentList(res?.data?.data);
            }
        } catch (error) {
            console.error(error);
        }

    }

    useEffect(() => {
        scheduleInstreamList();
        contentManagementList();
    }, [])

    return (
        <>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Permission code={AUTH_CODE.accounts.publisherListing}>
                    <Link to={'/active-publisher'}><span>Publisher</span></Link>
                </Permission>
                <span>{publisherName}</span>
                <Link to={`/publisher/instream-setting-list/${accId}/${pubGuid}`}><span>Manage Instream Setting</span></Link>
                <span>Schedule Instream</span>
                {/* <span>{instreamId}</span> */}
            </div>
            <Row>
                <Permission code={AUTH_CODE.instreamTagSetting.instreamScheduleSettings}>
                    <div className="col-12">
                        <Card className="p-3 instreamRows">
                            <h4 className="title_txt title_txt title_txtsm text-danger">All fields marked with * are mandatory</h4>
                            <h3 className="text-primary title" >Instream Schedule Settings</h3>

                            <div style={{ background: "#f5f5f5", padding: "25px" }}>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Form.Group className="mt-4">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Form.Label>Content Management *</Form.Label>
                                                <Form.Select {...register("contentId")}>

                                                    <option value="">-- Select Content --</option>

                                                    {contentList.map((item, index) => (
                                                        <option key={item.id || index} value={item.id}>
                                                            {item?.name}
                                                        </option>
                                                    ))}

                                                </Form.Select>
                                            </div>
                                            <div className="col-md-6">
                                                {/* Start Date * */}
                                                <Form.Label>Start Date *</Form.Label>
                                                <InputGroup>
                                                    <Form.Control
                                                        type="date"
                                                        min={new Date().toISOString().split("T")[0]}
                                                        {...register("startDate")}
                                                    />
                                                    <InputGroup.Text>
                                                        📅
                                                    </InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <input className="btn btn-primary" type="submit" value="Submit" />
                                    </Form.Group>
                                </form>
                            </div>
                        </Card>
                    </div>
                </Permission>
            </Row>
            <Row>
                <div className="active-table-wrapper">
                    <div className="table-scroll">
                        <Table bordered hover size="sm">
                            <thead style={{ background: "#ddd", position: "sticky", top: 0 }}>
                                <tr>
                                    <th>Video Content</th>
                                    <th>Scheduled Date</th>
                                    <th>Action</th>
                                </tr>
                            </thead>

                            <tbody>
                                {list.map((item) => (
                                    <tr key={item?.contentName}>
                                        <td>{item?.contentName}</td>
                                        <td>{item?.scheduleDate}</td>
                                        <td >
                                            <Permission code={AUTH_CODE.instreamTagSetting.deleteInstreamScheduleSetting}>
                                                <Button onClick={() => deleteScheduledContent(item?.id, item?.contentName)} size="sm">Delete</Button>
                                            </Permission>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <div style={{ background: "#e0e0e0", border: "1px solid #ababab", bordertop: "none", padding: "3px" }}>
                            Total size : {list.length}
                        </div>
                    </div>
                </div>
            </Row>
        </>
    )
}
export default ScheduleInstreamSetting;